import PropTypes from 'prop-types';
// import { useRef } from 'react';
import ReactDOM from 'react-dom';
import ArcButton from '../arcButton/index';
import dialog from './AidBottomDialog.module.scss';

function Button(props) {
  const { children, onClick, 'aria-label': ariaLabel } = props;
  return (
    <button
      type="button"
      className={dialog.button}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  'aria-label': PropTypes.string,
};

Button.defaultProps = {
  onClick: () => {},
  'aria-label': undefined,
};

function Dialog(props) {
  const {
    height,
    visible,
    onOk,
    onCancel,
    maskClosable,
    children,
    btnStyle,
    ButtonCount,
  } = props;

  const {
    cancelBtnName,
    okBtnName,
    btnWidth,
    btnHeight,
    backgroundColor,
    centerWidth,
    BtnMarginBottom,
  } = btnStyle;

  const handlerCloseDialog = () => {
    if (!maskClosable) {
      onCancel();
    }
  };
  return (
    visible ? (
      ReactDOM.createPortal(
        <div
          aria-hidden
          className={dialog['dialog-content']}
          onClick={() => handlerCloseDialog()}
        >
          <div
            aria-hidden
            onClick={(event) => { event.stopPropagation(); }}
            className={dialog['modal-content']}
            style={{ width: '100%', height: height ? `${height}rem` : 'auto' }}
          >
            <div>
              {children}
            </div>
            <div className={dialog['modal-footer']} style={{ marginBottom: BtnMarginBottom }}>
              {
                ButtonCount === 1
                  ? (
                    // <ArcButton
                    //   text={okBtnName}
                    //   backgroundColor={backgroundColor[0]}
                    //   onClick={onCancel}
                    //   width={btnWidth}
                    //   height={btnHeight}
                    //   handleChecked={onOk}
                    // />
                    null
                  )
                  : (
                    <>
                      <ArcButton
                        text={cancelBtnName}
                        backgroundColor={backgroundColor[0]}
                        onClick={onCancel}
                        width={btnWidth}
                        height={btnHeight}
                        handleChecked={onCancel}
                      />
                      <div style={{ width: centerWidth }} />
                      <ArcButton
                        text={okBtnName}
                        backgroundColor={backgroundColor[1]}
                        onClick={onOk}
                        width={btnWidth}
                        height={btnHeight}
                        handleChecked={onOk}
                      />
                    </>
                  )
              }
            </div>
          </div>
        </div>,
        document.getElementById('root'),
      )
    ) : null
  );
}

Dialog.propTypes = {
  height: PropTypes.number,
  visible: PropTypes.bool.isRequired,
  children: PropTypes.element,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  maskClosable: PropTypes.bool,
  ButtonCount: PropTypes.number,
  btnStyle: PropTypes.oneOfType([PropTypes.object]),
};

Dialog.defaultProps = {
  children: (null),
  onCancel: () => {}, // 点击取消按钮事件
  onOk: () => {}, // 点击确认按钮事件
  maskClosable: false, // 点击遮罩是否关闭弹框
  height: 18.125, // 弹框高度
  ButtonCount: 2, // 设置底部按钮个数
  btnStyle: {},
};

Dialog.Button = Button;

export default Dialog;
